export default __webpack_public_path__ + "static/media/needle.7c269792.png";